import {useState,useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {
	createMAXFood,
	setEditor,
	selectFoodById,
	editMAXFood
} from './MAXSlice'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'


//mode = edit | new
const MAXFoodEditor = ()=>{
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()

	const {show,mode,id} = useSelector(state=>state.MAXFoods.foods.editor)
	const food = useSelector(state=>mode==='edit'&&selectFoodById(state,id))

	const onHide = ()=>{
		dispatch(setEditor({
			show:false,
			mode:null,
			id:null
		}))
	}

	const [name,setName] = useState('')
	const [protein,setProtein] = useState('')
	const [carbs,setCarbs] = useState('')
	const [fruits,setFruits] = useState('')
	const [vegetables,setVegetables] = useState('')
	const [fats,setFats] = useState('')

	useEffect(()=>{
		if(mode==='create') return
		setName(food.name)
		setProtein(food.protein)
		setCarbs(food.carbs)
		setFruits(food.fruits)
		setVegetables(food.vegetables)
		setFats(food.fats)
	},[show,id])

	const handleSave = ()=>{
		if(mode === 'create'){
			statusDispatch(
				createMAXFood({name,protein,carbs,fruits,vegetables,fats}),
				'food','create'
			)
		}else{
			statusDispatch(
				editMAXFood({id,update:{name,protein,carbs,fruits,vegetables,fats}}),
				'food','edit'
			)
		}
	}

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>MAX Food Editor</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<strong>Name</strong>
				<Form.Control 
					onChange={e=>{ setName(e.target.value) }}
					value={name}
					placeholder="name"
				/>

				<strong>Protein</strong>
				<Form.Control 
					onChange={e=>{ setProtein(e.target.value) }}
					value={protein}
					placeholder="protein" 
					type="number"
				/>

				<strong>Carbs</strong>
				<Form.Control 
					onChange={e=>{ setCarbs(e.target.value) }}
					value={carbs}
					placeholder="carbs" 
					type="number"
				/>

				<strong>Fruits</strong>
				<Form.Control 
					onChange={e=>{ setFruits(e.target.value) }}
					value={fruits}
					placeholder="fruits" 
					type="number"
				/>

				<strong>Vegetables</strong>
				<Form.Control 
					onChange={e=>{ setVegetables(e.target.value) }}
					value={vegetables}
					placeholder="vegetables" 
					type="number"
				/>

				<strong>Fats</strong>
				<Form.Control 
					onChange={e=>{ setFats(e.target.value) }}
					value={fats}
					placeholder="fats" 
					type="number"
				/>

				<Button 
					onClick={handleSave}
					className="mt-2" 
					variant="outline-success" 
					block
				>
					Save
				</Button>
			</Modal.Body>
		</Modal>
	)
}


export default MAXFoodEditor